var map = {
	"./Foram_and_Radiolarian_23 (17).jpg": 6314,
	"./Foram_and_Radiolarian_23 (18).jpg": 7158,
	"./Foram_and_Radiolarian_23 (3).jpg": 3695,
	"./Foram_and_Radiolarian_23 (4).jpg": 8507,
	"./Foram_and_Radiolarian_23 (7).jpg": 12,
	"./Foram_and_Radiolarian_23 (8).jpg": 7318,
	"./Foraminifera_Inside_spiral_01 (5).jpg": 1597,
	"./Foraminifera_Inside_spiral_01 (6).jpg": 7500,
	"./Radiolarian_22.jpg": 4338
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4884;